<template>
  <v-layout>
    <v-flex>
      <v-layout wrap align-center>
        <h1 class="headline">Accommodation</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 class="pb-2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="search"
            class="ma-0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              fab
              dark
              color="primary"
              @click="createItem"
              class="ma-2"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Accommodation Supplier</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
          fixed-header
          hide-default-footer
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
          <template v-slot:item.notInUse="{ item }">
            <v-simple-checkbox
              v-model="item.node.notInUse"
              disabled
            ></v-simple-checkbox>
          </template>
        </v-data-table>
      </v-card>
      <v-card>
        <v-dialog v-model="accommodationEditorDialog" persistent width="500">
          <v-card>
            <accommodation-editor
              :accommodation="selectedAccommodation"
              :doSaveAccommodation="doSaveAccommodation"
              :accommodationEditorDialog="accommodationEditorDialog"
              @saved="onSaved($event)"
              @onResetSave="onResetSave"
            ></accommodation-editor>
            <v-card-actions class="grey lighten-4">
              <v-spacer></v-spacer>
              <v-btn color="warning" text @click="closeDialog">Cancel</v-btn>
              <v-btn color="primary" @click="onSaveAccommodation">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_ACCOMMODATION_SUPPLIER_TYPES_SEARCH_QUERY,
  ACCOMMODATION_SUPPLIER_TYPE_DELETE_MUTATION,
} from "../../../../constants/graphql";
import AccommodationEditor from "./AccommodationEditor";
import DefaultListActions from "../../shared/DefaultListActions";
import { pagingOptions } from "../../../../helpers/index";
import { ListMixin } from "../../../../mixins/ListMixin";
export default {
  name: "AccommodationTypesList",
  mixins: [ListMixin],
  components: {
    DefaultListActions,
    AccommodationEditor,
  },

  data() {
    return {
      pagingOptions,
      search: "",
      selectedAccommodation: {},
      accommodationSupplierTypes: {},
      accommodationEditorDialog: false,
      doSaveAccommodation: false,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "node.name",
          name: "name",
        },
        {
          text: "Not In Use",
          value: "notInUse",
          name: "notInUse",
          align: "center",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.accommodationSupplierTypes
        ? this.accommodationSupplierTypes.edges
        : [];
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    createItem() {
      this.selectedAccommodation = {};
      this.accommodationEditorDialog = true;
    },
    editItem(item) {
      this.selectedAccommodation = item.node;
      this.accommodationEditorDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: ACCOMMODATION_SUPPLIER_TYPE_DELETE_MUTATION,
          variables: {
            accommodationSupplierId: item.node.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: "Accommodation supplier type removed.",
      });
      if (this.$apollo.queries.accommodationSupplierTypes != null) {
        this.$apollo.queries.accommodationSupplierTypes.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error",
      });
    },
    onSaved(context) {
      if (this.$apollo.queries.accommodationSupplierTypes != null) {
        this.$apollo.queries.accommodationSupplierTypes.refetch();
      }
      this.onResetSave();
      this.accommodationEditorDialog = false;
      this.selectedAccommodation = {};
      let msg =
        context == "edit"
          ? "Accommodation supplier type updated."
          : "Accommodation supplier type created.";
      this.$store.dispatch("showAppSnackbar", { msg });
    },
    onResetSave() {
      this.doSaveAccommodation = false;
    },
    closeDialog() {
      this.accommodationEditorDialog = false;
      this.selectedAccommodation = {};
    },
    onSaveAccommodation() {
      this.doSaveAccommodation = true;
    },
  },

  apollo: {
    accommodationSupplierTypes: {
      query: ALL_ACCOMMODATION_SUPPLIER_TYPES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {},
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/AccommodationTypesList.vue